<template>
  <procedure-page
    :id="$route.params.id"
    :procedure="procedure"
    :load-func="load"
    :status="procedure.step"
    :types="types"
    :isClosed="procedure.isClosed"
    @update:procedureGoodName="procedure.goodName = $event"
    @update:procedureType="procedure.type = $event"
  >
    <decision-grid v-if="procedure.id"
      :procedureId="procedure.id"
      :procedure-type="procedure.type"
      :status="procedure.step.code"
      :applications="applications"
      :isNds="procedure.isNds"
      :successful="null"
    />
    <div class="d-flex justify-end ga-3">
      <v-btn
        flat
        color="primary"
        density="comfortable"
        variant="outlined"
        @click="goToProcedures"
      >{{ $t('Отмена') }}</v-btn>
      <v-btn
        flat
        color="primary"
        density="comfortable"
        variant="elevated"
        :disabled="!valid"
        :loading="loading"
        @click="confirm($route.params.id)"
      >{{ $t('Подтвердить') }}</v-btn>
    </div>
  </procedure-page>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { toast } from '@/lib/toast';
import api from '../api';

import ProcedurePage from "../components/ProcedurePage.vue";
import DecisionGrid from "../components/application/DecisionGrid.vue";

interface Procedure {
  id?: number
  registryNumber?: string
  type?: string
  goodName?: string
  subject?: string
  startMaxPrice?: string
  applicationDeadline?: null
  reviewDeadline?: null
  shippingCondition?: string
  publishedAt?: null
  organizerName?: string
  isNds?: boolean
  isClosed: boolean
  step: {
    name: string
    code: string
  }
  [key: string]: any
}

interface Application {
  isAccepted?: boolean
  [key: string]: any
}

const procedure = reactive<Procedure>({
  id: null,
  registryNumber: '',
  type: '',
  goodName: '',
  subject: '',
  startMaxPrice: '',
  applicationDeadline: null,
  shippingCondition: '',
  publishedAt: null,
  organizerName: '',
  isNds: null,
  isClosed: false,
  step: { name: '', code: '' },
});
const applications = ref<Application[]>([]);
const types = ref<{
  title: string
  value: string
}[]>([]);
const loading = ref(false);

const valid = computed<boolean>(() => !applications.value.find(
    ({ isAccepted }) => isAccepted === null)
);

const load = async procedureId => {
  const resp = await api.get(`/procedures/${procedureId}/review`);
  Object.assign(procedure, resp.procedure);
  applications.value = resp.applications;
  types.value = resp.types.map((elem) => ({
    title: elem.name,
    value: elem.code,
  }));
};

const router = useRouter();
const goToProcedures = () => router.push({ name: 'procedures.all' });

const confirm = async procedureId => {
  try {
    loading.value = true;
    const formData = new FormData();
    formData.append('data', JSON.stringify(applications.value));
    await api.post(`/procedures/${procedureId}/review`, formData);
    toast.info('Процедура обновлена успешно');
    goToProcedures();
  } catch (e) {
    toast.error(e.message);
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped lang="scss">
button {
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  padding: 10px 20px;
  height: auto !important;
  border-radius: 6px;
}
</style>
